var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var stdin_exports = {};
__export(stdin_exports, {
  LazyGetter: () => LazyGetter,
  default: () => defineLazyGetter
});
module.exports = __toCommonJS(stdin_exports);
const globalLazyGetterCache = /* @__PURE__ */ new WeakMap();
const sym = Symbol("lazyGetterCache");
const getCache = (o) => {
  if (!Object.isExtensible(o)) {
    let ans2 = globalLazyGetterCache.get(o);
    if (!ans2)
      globalLazyGetterCache.set(o, ans2 = {});
    return ans2;
  }
  let ans = o[sym];
  if (!ans) {
    Object.defineProperty(o, sym, {
      enumerable: false,
      configurable: true,
      value: ans = {}
    });
  }
  return ans;
};
function wrapGetter(key, getter) {
  return function() {
    const cache = getCache(this);
    const called = key in cache;
    const value = called ? cache[key] : getter.call(this);
    if (!called)
      Object.defineProperty(cache, key, { value });
    return value;
  };
}
function defineLazyGetter(obj, key, getter) {
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: wrapGetter(key, getter)
  });
}
const LazyGetter = () => (target, key, desc) => {
  desc.get = wrapGetter(key, desc.get);
};
